const RAILSUI_MODAL = 'railsui-modal';
const CONTROLLER_WAIT_ATTEMPTS = 20;
const CONTROLLER_WAIT_FRAME_MS = 16;

function stimulusApplication() {
  return typeof window !== 'undefined' ? window.Stimulus : null;
}

function waitOneFrame() {
  return new Promise((resolve) => {
    if (typeof requestAnimationFrame === 'function') {
      requestAnimationFrame(() => {
        setTimeout(resolve, CONTROLLER_WAIT_FRAME_MS);
      });
      return;
    }
    setTimeout(resolve, CONTROLLER_WAIT_FRAME_MS);
  });
}

export function railsuiModalContainer(modalRoot) {
  return modalRoot?.querySelector('[data-railsui-modal-target="container"]') ?? null;
}

export function railsuiModalController(modalRoot, application = stimulusApplication()) {
  if (!application || !modalRoot) return null;
  return application.getControllerForElementAndIdentifier(modalRoot, RAILSUI_MODAL);
}

/** Block Aquifer UI Escape dismiss — required actions only. */
export function disableRailsuiEscape(modalRoot) {
  const container = railsuiModalContainer(modalRoot);
  if (!container) return;

  const action = container.getAttribute('data-action') || '';
  const filtered = action
    .split(/\s+/)
    .filter((entry) => entry && !entry.includes('closeWithEsc'))
    .join(' ')
    .trim();

  if (filtered) container.setAttribute('data-action', filtered);
  else container.removeAttribute('data-action');
}

export async function waitForRailsuiModalController(modalRoot, attempts = CONTROLLER_WAIT_ATTEMPTS) {
  for (let i = 0; i < attempts; i += 1) {
    const controller = railsuiModalController(modalRoot);
    if (controller) return controller;
    await waitOneFrame();
  }
  return null;
}

export async function showRailsuiModal(modalRoot, { disableEscape = false } = {}) {
  if (!modalRoot) return false;

  if (disableEscape) {
    disableRailsuiEscape(modalRoot);
  }

  const railsui = await waitForRailsuiModalController(modalRoot);
  if (!railsui) return false;

  railsui.show();
  return true;
}

export function hideRailsuiModal(modalRoot) {
  if (!modalRoot) return;

  const railsui = railsuiModalController(modalRoot);
  if (railsui?.isOpen) {
    railsui.close();
  }
}
